<template>
  <div class="course-header">
    <div style="display: flex;align-items: center">
      <img style="width: 20px;height: 20px" src="https://img.aixuejie.cn/axj_web_file/icon/WechatIMG124.png">
    </div>
    <div class="axj-main-body-page-info">
      资讯·课程
    </div>
    <div @click="handleCreate" class="axj-main-body-create">
      <button>
        <span class="icon">+</span><span class="text">发布</span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "course-header",
  methods:{
    handleCreate(){
      console.log(1)
      this.$emit("create")
    }
  }
}
</script>

<style scoped lang="scss">
.course-header {
  margin-bottom: 3px;
  height: 37.98px;
  display: flex;
  width: 100%;
  .axj-main-body-create {
    margin-left: auto;
    display: flex;
    button {
      margin: 0;
      padding: 0;
      border: 1px solid transparent; //自定义边框
      outline: none;
      font-size: 14.6px;
      width: 101.25px;
      color: #ffffff;
      cursor: pointer;
      font-style: normal;
      font-weight: normal;
      //line-height: 48.186px;
      border-radius: 5px;
      letter-spacing: 0.046em;
      background: #00ADB5;
      display: flex;
      font-size: 20.45px;
      align-items: center;
      justify-content: center;
      span[class=text]{
        //line-height: 0;
        position: relative;
      }
      span[class=icon]{
        //line-height: 0;
        font-size: 35.6px;
      }
    }
  }
  .axj-main-body-page-info{
    font-family: Source Han Sans CN;
    font-style: normal;
    font-weight: normal;
    font-size: 17.53px;
    line-height: 225.3%;
    margin-left: 10px;
    /* identical to box height, or 53px */
    color: #41555D;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/axj-help/axj-course/component/course-header/index.vue